<template>
  <nav class="navbar navbar-expand navbar-theme">
    <a class="sidebar-toggle d-flex me-2" @click.prevent="toggleSidebar">
      <i class="hamburger align-self-center"></i>
    </a>

    <form class="d-none d-sm-inline-block">
      <input
        class="form-control form-control-lite"
        type="text"
        placeholder="Search projects..."
      />
    </form>

    <div class="navbar-collapse collapse">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item dropdown active">
          <a
            class="nav-link dropdown-toggle position-relative"
            href="#"
            id="messagesDropdown"
            data-bs-toggle="dropdown"
          >
            <i class="align-middle fas fa-envelope-open"></i>
          </a>
          <div
            class="dropdown-menu dropdown-menu-lg dropdown-menu-end py-0"
            aria-labelledby="messagesDropdown"
          >
            <div class="dropdown-menu-header">
              <div class="position-relative">0 New Messages</div>
            </div>
            <div class="list-group" v-if="1 == 0">
              <a href="#" class="list-group-item">
                <div class="row g-0 align-items-center">
                  <div class="col-2">
                    <img
                      src="/theme/user.png"
                      class="avatar img-fluid rounded-circle"
                      alt="Michelle Bilodeau"
                    />
                  </div>
                  <div class="col-10 ps-2">
                    <div class="text-dark">Michelle Bilodeau</div>
                    <div class="text-muted small mt-1">
                      Nam pretium turpis et arcu. Duis arcu tortor.
                    </div>
                    <div class="text-muted small mt-1">5m ago</div>
                  </div>
                </div>
              </a>
            </div>
            <div class="dropdown-menu-footer">
              <router-link :to="{ name: 'writer.messages' }" class="text-muted"
                >Show all messages</router-link
              >
            </div>
          </div>
        </li>
        <li class="nav-item dropdown ms-lg-2">
          <a
            class="nav-link dropdown-toggle position-relative"
            href="#"
            id="alertsDropdown"
            data-bs-toggle="dropdown"
          >
            <i class="align-middle fas fa-bell"></i>
            <!-- <span class="indicator"></span> -->
          </a>
          <div
            class="dropdown-menu dropdown-menu-lg dropdown-menu-end py-0"
            aria-labelledby="alertsDropdown"
          >
            <div class="dropdown-menu-header">0 New Notifications</div>
            <div class="list-group" v-if="1 == 0">
              <a href="#" class="list-group-item">
                <div class="row g-0 align-items-center">
                  <div class="col-2">
                    <i class="ms-1 text-danger fas fa-fw fa-bell"></i>
                  </div>
                  <div class="col-10">
                    <div class="text-dark">Update completed</div>
                    <div class="text-muted small mt-1">
                      Restart server 12 to complete the update.
                    </div>
                    <div class="text-muted small mt-1">2h ago</div>
                  </div>
                </div>
              </a>
            </div>
            <div class="dropdown-menu-footer">
              <router-link :to="{ name: 'writer.notifications' }" class="text-muted"
                >Show all notifications</router-link
              >
            </div>
          </div>
        </li>
        <li class="nav-item dropdown ms-lg-2">
          <a
            class="nav-link dropdown-toggle position-relative"
            href="#"
            id="userDropdown"
            data-bs-toggle="dropdown"
          >
            <i class="align-middle fas fa-user"></i>
          </a>
          <div
            class="dropdown-menu dropdown-menu-end"
            aria-labelledby="userDropdown"
          >
            <router-link class="dropdown-item" :to="{ name: 'writer.profile' }"
              ><i class="align-middle me-1 fas fa-fw fa-user"></i> My Account</router-link
            >
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#" @click.prevent="logout"
              ><i
                class="align-middle me-1 fas fa-fw fa-arrow-alt-circle-right"
              ></i>
              Sign out</a
            >
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  methods: {
    toggleSidebar() {
      let sidebar = document.getElementById("sidebar");

      sidebar.classList.toggle("toggled");
    },

    logout() {
      this.$axios.post('/api/v1/logout').then(() => {
        this.$storage.remove('token')
        window.location.href = this.$router.resolve({ name: 'login' }).href
      })
    }
  }
};
</script>
